module.exports = __webpack_public_path__ + "img/image_7.c28b9a3b.png";